import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { ContentHeaderKey } from "src/app/constants/content-header";
import { PTOModel } from "src/app/models/payroll";
import { PayrollService } from "src/app/services/payroll.service";

@Component({
    selector: 'mwp-pto-sick-hours',
    templateUrl: './pto-sick-hours.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class PayrollPTOSickHoursComponent implements OnInit {
    public apiUrl = ContentHeaderKey.PayrollPTOSickHours;
    public ptoModel: PTOModel;
    public ptoForm: FormGroup;
    public sickLeaveForm: FormGroup;

    constructor(
        private payrollService: PayrollService,
        private formBuilder: FormBuilder,
    ) { }

    ngOnInit(): void {
        this.payrollService.getPTO().subscribe((response: PTOModel) => {
            this.ptoModel = response;
            this, this.createForms();
        });
    }

    private createForms(): void {
        this.ptoForm = this.formBuilder.group({
            ptoHoursAvailable: [{ value: this.ptoModel.vacationAvailable, disabled: true }],
            ptoHoursAccrued: [{ value: this.ptoModel.vacationAccured, disabled: true }],
            ptoHoursSpent: [{ value: this.ptoModel.vacationUsed, disabled: true }],
        });
        this.sickLeaveForm = this.formBuilder.group({
            sickLeaveHoursAvailable: [{ value: this.ptoModel.sickLeaveAvailable, disabled: true }],
            sickLeaveHoursAccrued: [{ value: this.ptoModel.sickLeaveAccured, disabled: true }],
            sickLeaveHoursSpent: [{ value: this.ptoModel.sickLeaveUsed, disabled: true }],
        });

    }
}
